import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, TextField, Box, FormControl } from "@mui/material"
import { AutocompleteComponent } from "components/Autocomplete/AutocompleteComponent";
import { useFetchLocal } from "hooks/fetch-hooks/useFetchLocal"
import { handleUltimateFetchLessData } from "views/Closeouts-Settlements/actions/fetchData";
import RegularButton from "components/CustomButtons/Button";
import SearchIcon from "@mui/icons-material/Search";
import { blue } from "@mui/material/colors";
import {
    handleCreditsUnlockInputsAction,
    createCreditUnlockAction,
} from "redux/actions/creditsUnlock/creditsUnlockActions";
import { StationsComponent } from "components/CardTable/StationsComponent";
const filterCustomer = "ERP";


export const CreditsUnlockForm = (props) => {
    const { onClose } = props;
    const [
        [_data, loading, _success, _error, _message],
        fetchCustomers,
    ] = useFetchLocal(handleUltimateFetchLessData);
    const { station, searchCustomer, customer, customersOpt, comments } = useSelector(({ creditsUnlock }) => creditsUnlock);
    const { stations } = useSelector(({ companies }) => companies);
    const { isLoadingComp } = useSelector(({ search }) => search);
    const state = useSelector(state => state["creditsUnlock"]);
    const [errorComment, setErrorComment] = useState("")
    const [errorCustomer, setErrorCustomer] = useState("")
    const dispatch = useDispatch();

    const setValues = useCallback((value) => {
        value?.customersOpt && dispatch(handleCreditsUnlockInputsAction("customersOpt", value.customersOpt))
        value?.searchCustomer && dispatch(handleCreditsUnlockInputsAction("searchCustomer", value.searchCustomer))
    }, [dispatch])

    const handleSearchAccount = useCallback((e) => {
        e.preventDefault()
        fetchCustomers(station, searchCustomer, stations, setValues, "", filterCustomer);
    }, [station, searchCustomer, stations, fetchCustomers, setValues])

    const handleInputOnChange = useCallback(({ target }) => {
        if (target.value) setErrorComment("")
        dispatch(handleCreditsUnlockInputsAction("comments", target.value))
    }, [dispatch])

    const checkError = useCallback(() => {
        let errorStatus = false
        if (!customer?.value) {
            errorStatus = true
            setErrorCustomer("Selecciona una cuenta ")
        }
        if (comments.trim() === "") {
            errorStatus = true
            setErrorComment("Agregue Justificación")
        }
        return errorStatus
    }, [customer, comments])

    const handleSubmit = useCallback((e) => {
        e.preventDefault()
        if (checkError()) return
        const form = {
            idAccount: customer.idAccount,
            idStation: customer.idStation,
            comment: comments
        }
        dispatch(createCreditUnlockAction(form, onClose))
    }, [checkError, customer, comments, dispatch, onClose])

    useEffect(() => {
        dispatch(handleCreditsUnlockInputsAction("customer", null));
        dispatch(handleCreditsUnlockInputsAction("customersOpt", []));
        dispatch(handleCreditsUnlockInputsAction("searchCustomer", []))
    }, [station]);

    useEffect(() => {
        setErrorCustomer("")
    }, [customer])

    return (
        <FormControl
            fullWidth
            style={{ display: "flex", gap: 10, marginTop: 20, maxWidth: 450 }}
            onSubmit={handleSubmit}
        >
            <Grid container spacing={1} style={{ paddingRight: 0 }}>
                <StationsComponent
                    state={state}
                    stations={true}
                    multi={true}
                    gridWidth={12}
                    limitTags={3}
                    dispatchAction={handleCreditsUnlockInputsAction}
                />
                <Grid item xs={12} sm={11}>
                    <AutocompleteComponent
                        label={"Cuenta"}
                        size={"small"}
                        options={customersOpt || []}
                        name={"idAccount"}
                        value={customer || null}
                        search={searchCustomer}
                        customAction={v => dispatch(handleCreditsUnlockInputsAction("customer", v))}
                        disabled={loading}
                        textFieldProps={{
                            onChange: ({ target }) => dispatch(handleCreditsUnlockInputsAction("searchCustomer", target.value)),
                            error: errorCustomer,
                            helperText: errorCustomer,
                        }}
                        noOptionsText="No se encuentra cuenta"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={1}>
                    <RegularButton
                        type="submit"
                        justIcon
                        round
                        color="transparent"
                        size="sm"
                        onClick={handleSearchAccount}
                        loading={loading}
                        tooltip="Buscar Cliente"
                    >
                        <SearchIcon sx={{ color: blue[700] }} />
                    </RegularButton>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <TextField
                        variant="outlined"
                        label="Justificación"
                        name="comments"
                        value={comments}
                        onChange={handleInputOnChange}
                        fullWidth
                        multiline
                        rows={5}
                        error={!!errorComment}
                        helperText={errorComment}
                    />
                </Grid>
            </Grid>
            <Box sx={{ display: "flex", gap: 8, justifyContent: "space-between", }}>
                <RegularButton
                    color="transparent"
                    variant="contained"
                    onClick={onClose}
                    disabled={isLoadingComp?.loadingModCreditsUnlock}
                >
                    Cancelar
                </RegularButton>
                <RegularButton
                    color="info"
                    variant="contained"
                    onClick={handleSubmit}
                    loading={isLoadingComp?.loadingModCreditsUnlock}
                >
                    Crear
                </RegularButton>
            </Box>
        </FormControl>
    );
}